import React from 'react';
import { TextContentItem } from '../../../types';
import {Input, Spacing, Subhead, Textarea} from '@vkontakte/vkui';

export const TextEdit = ({ item }: { item: TextContentItem }) => {
  return (
    <>
      <Subhead>Текст</Subhead>
      <Spacing size={5} />
      <Input
        defaultValue={item.name}
        onChange={event => (item.name = event.target.value)}
        placeholder="Название поля"
      />
      <Spacing size={8} />
      <Textarea
        autoFocus={item.value === ''}
        rows={1}
        name={item._id}
        defaultValue={item.value}
        onChange={event => (item.value = event.target.value)}
        placeholder="Текст"
      />
    </>
  );
};
